import DashboardContainer from './containers/DashboardContainer'

export default DashboardContainer
